<template>
    <div>
        <div class="card-container m-3">
            <div class="card h-100 w-100">
                <div class="front-content">
                    <div class="content-container">
                        <slot name="title"></slot>
                    </div>
                </div>
                <div class="content">
                    <div class="heading d-flex justify-content-between w-100">
                        <div class="justify-content-center flex-fill button-container">
                            <slot></slot>
                        </div>
                        <div v-if="$slots.right">
                            <slot name="right" class="d-flex align-items-center"></slot>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import config from '@/plugins/config';

export default {
    name: 'DefaultMenu',
    computed: {
        menuBgColor() {
            return config.theme.menuBackgroundColor;
        }
    }
}
</script>
<style scoped>
.card-container {
    width: auto;
    height: 100px;
    position: relative;
    border-radius: 10px;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
    overflow: hidden;
}

.front-content {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.6s cubic-bezier(0.23, 1, 0.320, 1)
}

.content-container {
    font-size: 32px;
    font-weight: 700;
    opacity: 1;
    background: v-bind(menuBgColor);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    transition: all 0.6s cubic-bezier(0.23, 1, 0.320, 1)
}

.card .content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 10px;
    background: v-bind(menuBgColor);
    color: #E1E1E1;
    padding: 20px;
    line-height: 1.5;
    border-radius: 5px;
    transform: translateY(-96%);
    transition: all 0.6s cubic-bezier(0.23, 1, 0.320, 1);
}

.card .content .heading {
    font-size: 32px;
    font-weight: 700;
}

.card:hover .content {
    transform: translateY(0);
}

.card:hover .front-content {
    transform: translateY(20%);
}

.card:hover .front-content .heading {
    opacity: 0;
}

.denounce-container {
    height: 70vh;
    overflow-y: auto;
}

.heading>* {
    margin-inline-start: 0.5rem;
}

.heading>*:first-child {
    margin-inline-start: 0;
}

.setting-container {
    position: absolute;
    top: 10px;
    right: 10px;
}

.button-container > * {
    margin-left: 1rem;
}

.button-container > :first-child {
    margin-left: 0rem;
}
</style>
